import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/upgrade-shopify-store.png'


const _withScopeId = n => (_pushScopeId("data-v-84cbfc48"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "shopify",
  id: "shopify"
}
const _hoisted_2 = {
  class: "shopify__image",
  delay: 50
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "upgrade shopify store"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "shopify__text" }
const _hoisted_6 = {
  class: "shopify__text-title",
  delay: 100
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  class: "shopify__text-description",
  delay: 200
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _directive_motion_slide_visible_once_left = _resolveDirective("motion-slide-visible-once-left")!
  const _directive_motion_slide_visible_once_right = _resolveDirective("motion-slide-visible-once-right")!
  const _directive_motion_fade_visible_once = _resolveDirective("motion-fade-visible-once")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)), [
      [_directive_motion_slide_visible_once_left]
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_6, [
        _createTextVNode(" Upgrade "),
        _hoisted_7,
        _createTextVNode("your Shopify store with Customis3d for free now ")
      ])), [
        [_directive_motion_slide_visible_once_right]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_8, [
        _createTextVNode(" Create and sell products online using our 3D templates to bring your products and designs to life. Maximise your profits with no inventory, first-class products and fast shipping. ")
      ])), [
        [_directive_motion_slide_visible_once_right]
      ]),
      _withDirectives(_createVNode(_component_Button, {
        primary: "",
        class: "shopify__text-button",
        text: "Shopify app store",
        link: $setup.Urls.CUSTOMIS3D_SHOPIFY_APP
      }, null, 8, ["link"]), [
        [_directive_motion_fade_visible_once]
      ])
    ])
  ]))
}